import { CustomerReactionsCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function CustomerReactionsFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return (
    <CustomerReactionsCommandList multiselect selected={selection} onSelect={onSelect} />
  )
}
